const HIDE_RETIRED_SEARCH = "-[RETIRED]";

function handleSubmit(input_id, checkbox_id) {
  /*While this code seems redundant, it handles any submits to the form where the search terms have changed*/
  var checkbox = document.getElementById(checkbox_id);
  var search_input = document.getElementById(input_id);
  if(search_input) {
    var search_value = search_input.value;
    if(checkbox.checked) {
      if(!search_value.includes(HIDE_RETIRED_SEARCH)) {
        search_input.value = search_value + " " + HIDE_RETIRED_SEARCH;
      }
    }
    else {
      search_input.value = search_value.replaceAll(HIDE_RETIRED_SEARCH, "");
    }
  }
}


function hideShowRetiredProducts(checkbox, input_id, form_id) {
  var search_input = document.getElementById(input_id);
  if(search_input) {
    var search_value = search_input.value;
    var search_form = document.getElementById(form_id);

    var checkboxes = document.getElementsByClassName("hide_retired_checkbox_input");

    var submit_form = false;

    if(search_form) {
      if(checkbox.checked) {
        if(search_value.trim() != "") {
          submit_form = true;
          search_input.value = search_value + " " + HIDE_RETIRED_SEARCH;
        }

        if(checkboxes) {
          var num_checkboxes = checkboxes.length;
          for(var i = 0; i < num_checkboxes; i++) {
            checkbox.checked = true;    
          }
        }

      }
      else {
        search_input.value = search_value.replaceAll(HIDE_RETIRED_SEARCH, "");

        if(search_input.value.trim() != "") {
          submit_form = true;
        }

        if(checkboxes) {
          var num_checkboxes = checkboxes.length;
          for(var i = 0; i < num_checkboxes; i++) {
            var checkbox = checkboxes[i];
            checkbox.checked = false;    
          }
        }
      }
    }

    if(submit_form) {
      search_form.submit();
    }
  }
}


function setCountResultsText(hide_retired){
  var count_texts = document.getElementsByClassName("retired_products_txt");
  if(count_texts) {
    var num_texts = count_texts.length;

    for(var i = 0; i < num_texts; i++) {
      var current_text = count_texts[i];
      if(hide_retired) {
        current_text.innerHTML = " (WITHOUT Retired Products)";
      }
      else {
        current_text.innerHTML = " (WITH Retired Products)";
      }
    }
  }
}



function preparePageForSearch() {
  var set_checkboxes_true = false;


  var modal_details_1 = document.getElementById("Details-Modal-1");
  var modal_details_2 = document.getElementById("Details-Modal-2");

  if(modal_details_1 && modal_details_1.open) {
    //Search Modal Larger
    var search_input_modal_1 = document.getElementById("Search-In-Modal-1");
    if(search_input_modal_1 && search_input_modal_1.value.includes(HIDE_RETIRED_SEARCH)) {
      set_checkboxes_true = true;
    }
  }
  else if(modal_details_2 && modal_details_2.open) {
    //Search Modal Larger
    var search_input_modal = document.getElementById("Search-In-Modal");
    if(search_input_modal && search_input_modal.value.includes(HIDE_RETIRED_SEARCH)) {
      set_checkboxes_true = true;
    }
  }
  else {
    var search_input = document.getElementById("Search-In-Template");
    if(search_input) {
      var search_value = search_input.value;
      if(search_value.includes(HIDE_RETIRED_SEARCH) ) {
        set_checkboxes_true = true;
        setCountResultsText(true);
      }
      else {
        setCountResultsText(false);
      }
    }
  }


  if(set_checkboxes_true) {
    var checkboxes = document.getElementsByClassName("hide_retired_checkbox_input");
    if(checkboxes) {
      var num_checkboxes = checkboxes.length;
      for(var i = 0; i < num_checkboxes; i++) {
        var checkbox = checkboxes[i];
        checkbox.checked = true; 
      }
    }
  }


  //Hide "-[RETIRED]" from search terms and only show the checkbox is checked
  //Main Search Page
  var search_input_template = document.getElementById("Search-In-Template");
  if(search_input_template) {
    search_input_template.value = search_input_template.value.replaceAll(HIDE_RETIRED_SEARCH, "");
  }

  //Search Modal Larger
  var search_input_modal_1 = document.getElementById("Search-In-Modal-1");
  if(search_input_modal_1) {
    search_input_modal_1.value = search_input_modal_1.value.replaceAll(HIDE_RETIRED_SEARCH, "");
  }

  //Search Modal Smaller
  var search_input_modal = document.getElementById("Search-In-Modal");
  if(search_input_modal) {
    search_input_modal.value = search_input_modal.value.replaceAll(HIDE_RETIRED_SEARCH, "");
  }
    
}

window.onload = function() {
  preparePageForSearch();
}